import { render, staticRenderFns } from "./Remediation.vue?vue&type=template&id=533e4bac&"
import script from "./Remediation.vue?vue&type=script&lang=js&"
export * from "./Remediation.vue?vue&type=script&lang=js&"
import style0 from "./Remediation.vue?vue&type=style&index=0&id=533e4bac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports